<template>
  <div class="privacy-policy">
    <div class="privacy-policy__container">
      <Breadcrumbs/>
      <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">Политика обработки персональных данных</h1>

      <div class="privacy-policy__content">
        <p class="text-circe-16">
          КГБУЗ «Алтайский краевой клинический перинатальный центр» обрабатывает персональные данные
          в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».
          Настоящая страница размещена в соответствии со ст. 18.1 указанного закона.
        </p>
        <p class="text-circe-16">
          Полный текст положения об обеспечении безопасности персональных данных при их обработке
          в информационных системах персональных данных доступен для скачивания:
        </p>
        <button
          type="button"
          class="index-btn privacy-policy__download"
          :disabled="downloading"
          @click="downloadPolicy"
        >
          {{ downloading ? 'Загрузка…' : 'Скачать положение (PDF)' }}
        </button>
        <p class="text-circe-16">
          Документ также доступен в разделе
          <router-link to="/documents/institution" class="color-green">«Документы учреждения»</router-link>.
        </p>
        <p class="text-circe-16">
          Для отправки обращений и отзывов необходимо отдельное
          <router-link to="/appeal/consent" class="color-green">согласие на обработку персональных данных</router-link>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/BreadCrumbs.vue'
import { actionTypesDocuments } from '@/store/modules/documents'

const POLICY_FILE_NAME =
  'Положение об обеспечении безопасности персональных данных при их обработке в информационных системах персональных данных КГБУЗ АККПЦ.pdf'
const POLICY_FOLDER_PATH = '/app/documents/Документы учреждения'

export default {
  name: 'PrivacyPolicy',
  components: { Breadcrumbs },
  metaInfo() {
    return {
      title: 'Политика обработки персональных данных | Алтайский краевой клинический перинатальный центр ДАР',
      meta: [
        {
          name: 'description',
          content: 'Политика обработки персональных данных КГБУЗ «АККПЦ» в соответствии с 152-ФЗ.',
        },
      ],
    }
  },
  data() {
    return {
      downloading: false,
    }
  },
  methods: {
    async downloadPolicy() {
      if (this.downloading) return
      this.downloading = true
      try {
        const reportData = await this.$store.dispatch(actionTypesDocuments.downloadFile, {
          name: POLICY_FILE_NAME,
          currentPath: POLICY_FOLDER_PATH,
        })
        const { url, fileName } = reportData
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Ошибка загрузки политики ПД:', error)
      } finally {
        this.downloading = false
      }
    },
  },
}
</script>

<style scoped>
.privacy-policy__container {
  max-width: 960px;
  margin: 0 auto;
  padding: 24px 16px 48px;
}

.privacy-policy__content {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.privacy-policy__download {
  align-self: flex-start;
}
</style>
